import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMembersContext } from '@/contexts/membersContext';
import useAPI from '@/pages/members/hooks/useAPI';
import UserRepository from '@/repositories/members/UserRepository';

export const useMe = ({
  redirectOnFailure = true,
  supressErrorMessage = false
}: {
  redirectOnFailure?: boolean;
  supressErrorMessage?: boolean;
}) => {
  const userRepository = UserRepository();
  const { setMemberData } = useMembersContext();
  const navigate = useNavigate();

  const query = useAPI({
    queryKey: ['me'],
    queryFn: userRepository.me,
    refetchOnWindowFocus: false,
    supressMessages: supressErrorMessage
  });

  useEffect(() => {
    if (query.data) {
      setMemberData(query.data);
    }
  }, [query.data]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (query.error && redirectOnFailure) {
      const axiosError = query.error as AxiosError;
      if (axiosError.response?.status === 401 || axiosError.response?.status === 403) {
        navigate('/onboarding', { replace: true });
      }
    }
  }, [query.error, navigate, redirectOnFailure]);

  return query;
};
